export default __webpack_public_path__ + "static/media/purifieddaggamalt.ee74792c.jpg";